// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./packages/neos-media-browser/src/Variants/react_crop.vanilla-css
// module id = 22
// module chunks = 0